module.exports = "<img id='main-logo' src='assets/img/logo.png' alt='3D Digital Venue Main logo'>\n"